import { CurrentLendersState } from './CurrentLenderTypes';
import {
  CURRENT_LENDERS,
  LOAD_CURRENT_LENDERS_OK,
  LOADING_CURRENT_LENDERS,
  LOAD_CURRENT_LENDERS_ERR,
  EDIT_CURRENT_LENDER,
  CREATE_CURRENT_LENDER,
  emptyLender,
  CANCEL_CURRENT_LENDER_FORM,
} from './CurrentLenderConstants';
import { CurrentLender } from '../../../types';

export default function(state = CURRENT_LENDERS, action: any): CurrentLendersState {
  switch (action.type) {
    case EDIT_CURRENT_LENDER:
      const lender: CurrentLender = action.payload;
      return {
        ...state,
        form: {
          enabled: true,
          data: lender,
        },
      };
    //
    case CREATE_CURRENT_LENDER:
      return {
        ...state,
        form: {
          enabled: true,
          data: { ...emptyLender },
        },
      };
    //
    case CANCEL_CURRENT_LENDER_FORM:
      return { ...state, form: { ...state.form, enabled: false } };

    case LOAD_CURRENT_LENDERS_OK:
      const lenders: Array<CurrentLender> = action.payload;
      return { ...state, lenders, loadState: 2, form: { ...state.form, enabled: false } };
    //
    case LOADING_CURRENT_LENDERS:
      return { ...state, loadState: 1 };

    case LOAD_CURRENT_LENDERS_ERR:
      return { ...state, loadState: 0 };

    default:
      return state;
  }
}
